import { render, staticRenderFns } from "./EditCategory.vue?vue&type=template&id=10de45cc&scoped=true&"
import script from "./EditCategory.vue?vue&type=script&lang=js&"
export * from "./EditCategory.vue?vue&type=script&lang=js&"
import style0 from "./EditCategory.vue?vue&type=style&index=0&id=10de45cc&prod&lang=css&"
import style1 from "./EditCategory.vue?vue&type=style&index=1&id=10de45cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10de45cc",
  null
  
)

export default component.exports